import { useEffect, useState } from "react";
import { useMutation, useQueries, useQuery } from "react-query";
import { Link, useLocation, useParams } from "react-router-dom";
//primereact
import { Button } from "primereact/button";
import { Skeleton } from "primereact/skeleton";
import { BreadCrumb } from "primereact/breadcrumb";
import { TabPanel, TabView } from "primereact/tabview";
//components
import Panel from "../../../../components/panel/panel";
import Modal from "../../../../components/modal/Modal";
//pages
import Entry from "./Entry";
import Discounts from "./Discounts";
import Financing from "./Financing/Financing";
import SingleParcel from "./SingleParcel";
import Intermediate from "./Intermediate";
import Amortization from "./Amortization";
import ConstructionParcel from "./ConstructionParcel";
//services
import { getEntry } from "../../../../services/Settings/Simulator/getEntry";
import { getDiscounts } from "../../../../services/Settings/Simulator/getDiscounts";
import { getAmortization } from "../../../../services/Settings/Simulator/getAmortization";
import { getIntermediate } from "../../../../services/Settings/Simulator/getIntermediate";
import { getSingleParcel } from "../../../../services/Settings/Simulator/getSingleParcel";
import { postIntermediate } from "../../../../services/Settings/Simulator/postIntermediate";
import { postSingleParcel } from "../../../../services/Settings/Simulator/postSingleParcel";
import { getConstructionParcel } from "../../../../services/Settings/Simulator/getConstructionParcel";
import { postConstructionParcel } from "../../../../services/Settings/Simulator/postConstructionParcel";
import { queryClient } from "../../../../utils/queryClient";
import { useAppContext } from "../../../../context/AppContext";
import usePermission from "../../../../hooks/usePermission";

export default function SimulatorConfig() {
  const { id } = useParams();
  const { state } = useLocation();
  usePermission("88"); // Configurações do Simulador 
  const [activeIndex, setActiveIndex] = useState(0);
  const [visible, setVisible] = useState(false);
  const [selectIntermediate, setSelectIntermediate] = useState(false);
  const [selectConstructionParcel, setSelectConstructionParcel] =
    useState(false);
  const [selectSingleParcel, setSelectSingleParcel] = useState(false);
  const [loadingAditionals, setLoadingAditionals] = useState(false);
  const items = [
    {
      template: () => (
        <Link
          to={`/enterpriseSettings/${id}`}
          state={{ name: state ? state.name : "Empreendimento" }}
          className="p-breadcrumb-link"
        >
          Configurações do Empreendimento
        </Link>
      ),
    },
    {
      template: () => (
        <Link
          to={`/enterpriseSettings/simulator/${id}`}
          state={{ name: state ? state.name : "Empreendimento" }}
          className="p-breadcrumb-link"
        >
          Configurações do Simulador
        </Link>
      ),
    },
  ];
  const home = {
    template: () => (
      <Link to={"/salesManagement"} className="p-breadcrumb-link">
        <i className="fa fa-home"></i>
      </Link>
    ),
  };

  // const {
  //   data: dataFinancing,
  //   isLoading: isLoadingFinancing,
  //   refetch: refetchFinancing,
  // } = useQuery(`dataFinancing${id}`, () => getFinancing(id), {
  //   // cacheTime: 0,
  // });

  const queries = useQueries([
    {
      queryKey: [`dataAmortization${id}`],
      queryFn: () => getAmortization(id),
      // cacheTime: 0,
    },
    {
      queryKey: [`dataDiscount${id}`],
      queryFn: () => getDiscounts(id),
      // cacheTime: 0,
    },
    {
      queryKey: [`dataEntry${id}`],
      queryFn: () => getEntry(id),
      cacheTime: 0,
    },
    {
      queryKey: [`dataIntermediate${id}`],
      queryFn: () => getIntermediate(id),
      // cacheTime: 0,
    },
    {
      queryKey: [`dataConstructionParcel${id}`],
      queryFn: () => getConstructionParcel(id),
      // cacheTime: 0,
    },
    {
      queryKey: [`dataSingleParcel${id}`],
      queryFn: () => getSingleParcel(id),
      // cacheTime: 0,
    },
  ]);

  const isLoading = queries.some((query) => query.isLoading);
  const dataAmortization = queries[0].data;
  const dataDiscount = queries[1].data;
  const dataEntry = queries[2].data;
  const dataIntermediate = queries[3].data;
  const dataConstructionParcel = queries[4].data;
  const dataSingleParcel = queries[5].data;

  // Se precisar refetch
  const refetchAll = async () => {
    queries.forEach((query) => query.refetch());
  };


  const { mutateAsync: postIntermediateFn } = useMutation({
    mutationFn: postIntermediate,
    onSuccess(_, variables) {
      queryClient.setQueryData([`dataIntermediate${id}`], (data) => {
        const updatedData = data;
        updatedData.intermediate_enable = variables.intermediate_enable ? 1 : 0;
        return updatedData;
      });
    },
  });

  const { mutateAsync: postConstructionParcelFn } = useMutation({
    mutationFn: postConstructionParcel,
    onSuccess(_, variables) {
      queryClient.setQueryData([`dataConstructionParcel${id}`], (data) => {
        const updatedData = data;
        updatedData.construction_payments_enable = variables.construction_payments_enable;
        return updatedData;
      });
    },
  });

  const { mutateAsync: postSingleParcelFn } = useMutation({
    mutationFn: postSingleParcel,
    onSuccess(_, variables) {
      queryClient.setQueryData([`dataSingleParcel${id}`], (data) => {
        const updatedData = data;
        updatedData.single_installment_enable = variables.single_installment_enable;
        return updatedData;
      });
    },
  });

  useEffect(() => {
    if (dataIntermediate) {
      // console.log(dataIntermediate);
      setSelectIntermediate(dataIntermediate.intermediate_enable === 1);
    }
    if (dataConstructionParcel) {
      // console.log(dataConstructionParcel);
      setSelectConstructionParcel(
        dataConstructionParcel.construction_payments_enable
      );
    }
    if (dataSingleParcel) {
      // console.log(dataSingleParcel);
      setSelectSingleParcel(dataSingleParcel.single_installment_enable);
    }
  }, [dataIntermediate, dataConstructionParcel, dataSingleParcel]);

  const handleEditIntermediate = async () => {
    setLoadingAditionals(true);
    const data = {
      enterprise_id: parseInt(id),
      intermediate_enable: !selectIntermediate,
      intermediate_interest_rate: dataIntermediate.intermediate_interest_rate
        ? dataIntermediate.intermediate_interest_rate
        : 0,
      intermediate_max_installments:
        dataIntermediate.intermediate_max_installments
          ? dataIntermediate.intermediate_max_installments
          : 0,
      intermediate_percentage: dataIntermediate.intermediate_percentage
        ? dataIntermediate.intermediate_percentage
        : 0,
      intermediate_open: dataIntermediate.intermediate_open,
    };
    if (!selectIntermediate) {
      setActiveIndex(4);
    }
    if (activeIndex === 4 && !selectIntermediate === false) setActiveIndex(0);
    setSelectIntermediate(!selectIntermediate);
    await postIntermediateFn(data);
    // await refetchIntermediate();
    setLoadingAditionals(false);
  };

  const handleEditConstructionParcel = async () => {
    setLoadingAditionals(true);
    //    console.log(selectConstructionParcel);
    const data = {
      enterprise_id: parseInt(id),
      construction_payments_enable: !selectConstructionParcel,
      construction_payments_rate_interest:
        dataConstructionParcel.construction_payments_rate_interest
          ? dataConstructionParcel.construction_payments_rate_interest
          : 0,
      construction_payments_percentage:
        dataConstructionParcel.construction_payments_percentage
          ? dataConstructionParcel.construction_payments_percentage
          : 0,
      construction_payments_max:
        dataConstructionParcel.construction_payments_max
          ? dataConstructionParcel.construction_payments_max
          : 0,
    };
    if (!selectConstructionParcel) {
      setActiveIndex(5);
    }
    if (activeIndex === 5 && !selectConstructionParcel === false)
      setActiveIndex(0);
    setSelectConstructionParcel(!selectConstructionParcel);
    await postConstructionParcelFn(data);
    // await refetchConstructionParcel();
    setLoadingAditionals(false);
  };

  const handleEditSingleParcel = async () => {
    setLoadingAditionals(true);
    const data = {
      enterprise_id: parseInt(id),
      single_installment_enable: !selectSingleParcel,
      single_installment_percentage:
        dataSingleParcel.single_installment_percentage
          ? dataSingleParcel.single_installment_percentage
          : 0,
    };
    if (!selectSingleParcel) {
      setActiveIndex(6);
    }
    if (activeIndex === 6 && !selectSingleParcel === false) setActiveIndex(0);
    setSelectSingleParcel(!selectSingleParcel);
    await postSingleParcelFn(data);
    // await refetchSingleParcel();
    setLoadingAditionals(false);
  };

  useEffect(() => {
    if (!selectIntermediate && activeIndex === 4) {
      setActiveIndex(0);
    }
  }, [selectIntermediate, activeIndex]);

  useEffect(() => {
    if (state?.index >= 0) {
      setActiveIndex(state.index);
    }
  }, [state]);

  return (
    <>
      {isLoading ? (
        <>
          <div className="row d-flex justify-content-between mb-3">
            <div className="col-md-8">
              <BreadCrumb
                model={items}
                home={home}
                style={{
                  background: "transparent",
                  border: "none",
                  fontSize: "16px",
                }}
              />
            </div>
            <div className="col-md-2 text-end my-auto">
              <Skeleton width="100%" height="50px" />
            </div>
          </div>
          <div className="row mt-4">
            <Skeleton width="99%" height="640px" />
          </div>
        </>
      ) : (
        <>
          <div className="row d-flex justify-content-between mb-3">
            <div className="col-md-8">
              <BreadCrumb
                model={items}
                home={home}
                style={{
                  background: "transparent",
                  border: "none",
                  fontSize: "16px",
                }}
              />
            </div>
            <div className="col-md-4 text-end my-auto">
              <Button
                icon="fa fa-md fa-cog"
                onClick={() => setVisible(!visible)}
                severity="secondary"
                label="Configurações"
                className="w-100"
              />
            </div>
          </div>
          <Panel title="Configurações do Simulador">
            <TabView
              scrollable
              activeIndex={activeIndex}
              onTabChange={(e) => setActiveIndex(e.index)}
              className="meu-tabview pt-3"
            >
              <TabPanel
                header="Sistema de Amortização"
                leftIcon="pi pi-calendar mx-2"
              >
                <Amortization
                  setActiveIndex={setActiveIndex}
                  info={dataAmortization}
                  loading={isLoading}
                  refetch={refetchAll}
                />
              </TabPanel>
              <TabPanel
                header="Desconto"
                leftIcon="fa-solid fa-circle-dollar-to-slot mx-2"
              >
                <Discounts
                  setActiveIndex={setActiveIndex}
                  info={dataDiscount}
                  loading={isLoading}
                  refetch={refetchAll}
                />
              </TabPanel>
              <TabPanel header="Entrada" leftIcon="pi pi-chart-line mx-2">
                <Entry
                  setActiveIndex={setActiveIndex}
                  info={dataEntry}
                  loading={isLoading}
                  refetch={refetchAll}
                />
              </TabPanel>
              <TabPanel header="Financiamento" leftIcon="pi pi-dollar mx-2">
                <Financing
                  setActiveIndex={setActiveIndex}
                // loading={isLoadingFinancing}
                />
              </TabPanel>
              {selectIntermediate && (
                <TabPanel
                  header="Intermediária"
                  leftIcon="fa-solid fa-sliders mx-2"
                >
                  <Intermediate
                    setActiveIndex={setActiveIndex}
                    info={dataIntermediate}
                    loading={isLoading}
                    refetch={refetchAll}
                  />
                </TabPanel>
              )}
              {selectConstructionParcel && (
                <TabPanel
                  header="Parcelas de Obra"
                  leftIcon="fa-solid fa-screwdriver-wrench mx-2"
                >
                  <ConstructionParcel
                    setActiveIndex={setActiveIndex}
                    info={dataConstructionParcel}
                    refetch={refetchAll}
                  />
                </TabPanel>
              )}
              {selectSingleParcel && (
                <TabPanel
                  header="Parcela Única"
                  leftIcon="fa-solid fa-key mx-2"
                >
                  <SingleParcel
                    setActiveIndex={setActiveIndex}
                    info={dataSingleParcel}
                    refetch={refetchAll}
                  />
                </TabPanel>
              )}
            </TabView>
          </Panel>
          <Modal
            visible={visible}
            dynamicTitle={"Configurações do Simulador"}
            onHide={() => setVisible(!visible)}
            closable={true}
          >
            <h4 className="text-center">
              Selecione abaixo as opções que deseja no seu simulador
            </h4>
            <div className="row d-flex justify-content-around mt-4">
              <div className="col-md-4 my-3">
                <div
                  onClick={() => handleEditIntermediate()}
                  className={`card card-animation d-flex align-items-center p-5 h-100 text-center position-relative ${selectIntermediate && "bg-success text-white"
                    } ${loadingAditionals && "p-disabled"}`}
                  style={{ borderRadius: "15px" }}
                >
                  <h1 style={{ position: "absolute", right: 20, top: 10 }}>
                    <i className="fa-solid fa-check icon-modal"></i>
                  </h1>
                  <h1 style={{ fontSize: "50px" }}>
                    <i className="fa-solid fa-sliders"></i>
                  </h1>
                  <h2 className="my-auto">Intermediárias</h2>
                </div>
              </div>
              <div className="col-md-4 my-3">
                <div
                  onClick={() => handleEditConstructionParcel()}
                  className={`card card-animation d-flex align-items-center p-5 h-100 text-center position-relative ${selectConstructionParcel && "bg-success text-white"
                    } ${loadingAditionals && "p-disabled"}`}
                  style={{ borderRadius: "15px" }}
                >
                  <h1 style={{ position: "absolute", right: 20, top: 10 }}>
                    <i className="fa-solid fa-check icon-modal"></i>
                  </h1>
                  <h1 style={{ fontSize: "50px" }}>
                    <i className="fa-solid fa-screwdriver-wrench"></i>
                  </h1>
                  <h2 className="my-auto">Parcelas de Obra</h2>
                </div>
              </div>
              <div className="col-md-4 my-3">
                <div
                  onClick={() => handleEditSingleParcel()}
                  className={`card card-animation d-flex align-items-center p-5 h-100 text-center position-relative ${selectSingleParcel && "bg-success text-white"
                    } ${loadingAditionals && "p-disabled"}`}
                  style={{ borderRadius: "15px" }}
                >
                  <h1 style={{ position: "absolute", right: 20, top: 10 }}>
                    <i className="fa-solid fa-check icon-modal"></i>
                  </h1>
                  <h1 style={{ fontSize: "50px" }}>
                    <i className="fa-solid fa-tag"></i>
                  </h1>
                  <h2 className="my-auto">Parcela Única</h2>
                </div>
              </div>
            </div>
          </Modal>
        </>
      )}
    </>
  );
}
